// extracted by mini-css-extract-plugin
export var infoRow = "_r8-2";
export var labelContainer = "_r8-0";
export var rightInfo = "_r8-1";